import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { extractNumbers, MakeAxiosRequest } from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import Loader from "../../../Components/loader/Loader";
import UpdateInfoLayout from "./UpdateInfoLayout";

function AdditionalOptions(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    updateBillingInfo,
    handleBack,
    title='Additional Options'
  } = props;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control } =
    methods;
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [isShowInviteUser, setIsShowInviteUser] = useState(false);

  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    proxyType: [],
    additionalNeed: [],
    states: [],
    responsiblePartyList: [],
    otherRelation: [],
  });

  // const [responsiblePartyOther, setResponsiblePartyOther] = useState({});

  // const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');
  const submitUrl = profileEdit
    ? "/updateaditionalcustomerdetails"
    : "/updateaditionalrelationdetails";

  const fetchData = async () => {
    try {
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest(
          "post",
          "/getaditionalrelationdetails",
          { user_proxy_key: editKey, type: "additional_information" }
        );
        setPrefillDetails({
          ...edit.data.relationDetails,
          medical_types: edit.data.medical_types,
        });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "additional_information" });;
        setPrefillDetails({...profile.data.customerDetails});
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    // console.log(prefillDetails);

    setSubmitDisabled(false);
    reset({
      email: prefillDetails.email || "",
      phone_number: extractNumbers(prefillDetails.phone_number) || "",
      country_code: prefillDetails.country_code || "",
      invited_to_maxine: prefillDetails.invited_to_maxine || "",
    });
    // extractNumbers(prefillDetails.phone_number)!='' && setIsShowInviteUser(prefillDetails.invited_to_maxine == '0' ? true : false);
  }, [prefillDetails]);

  const submitData = async (data) => {
    // console.log(data);
    // return;
    setSubmitDisabled(true);
    if (updateBillingInfo) {
      updateBillingInfo(data);
    } else {
      try {
        data.state = data.state_id;
        data.phone_number = extractNumbers(data.phone_number);
        const response = await MakeAxiosRequest("post", submitUrl, {
          ...data,
          user_proxy_key: editKey,
          type: "additional_information",
        });
        // console.log(response);
        if (response.status == 1) {
          // getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')))
          reset();
          handleBack ? handleBack() : closeModal();
          listingFn && listingFn();
          // if(response.data?.msg_key =='subText'){
          //   SwalSuccess({subText: response.data?.message, showbtn:true})
          // }else{
          SwalSuccess({ msg: response.message });
          // }
          // profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };

  useEffect(() => {
    const walletPermission = watch("wallet_permission_enabled");
    if (walletPermission != "1") {
      // Clear phone number field validation
      trigger("phone_number");
    }
  }, [watch("wallet_permission_enabled")]);

  // Check validatecustomerexist
  useEffect(() => {
    const validateCustomer = async () => {
      const phoneNumber = watch("phone_number");
      if (phoneNumber && phoneRegex.test(phoneNumber)) {
        const res = await MakeAxiosRequest("post", "/validatecustomerexist", {
          phone_number: extractNumbers(phoneNumber),
          country_code: watch("country_code"),
        });
        // setIsShowInviteUser(res.data?.customer_exist == '0');
      }
    };
    if (
      extractNumbers(prefillDetails.phone_number) != watch("phone_number") ||
      prefillDetails.country_code != watch("country_code")
    )
      validateCustomer();
  }, [watch("phone_number"), watch("country_code")]);

  const fields = [
    {
      name: "wallet_permission_enabled",
      label: optionsList?.walletPermission?.permission_title,
      text: optionsList?.walletPermission?.permission_text,
      className: "col-12 mb-3",
      fieldClassName: "enable-payment",
      type: "agreeButton",
      isShow: profileEdit
        ? false
        : optionsList?.walletPermission?.is_show_permission,
    },
    {
      name: "invited_to_maxine",
      label: "Would you like to invite this person to Maxine?",
      // className: "col-12 mb-3",
      className: "col-12 mb-3",
      parentClassName: "d-flex",
      // optionsClassName: "col-6",
      // rules: { required: "Please select an option" },
      type: "radio",
      options: [
        {
          id: "1",
          name: "Yes",
        },
        {
          id: "0",
          name: "No",
        },
      ],
      // isShow: isShowInviteUser,
      isShow: true,
    },
    {
      name: "phone_number",
      countryCodeName: "country_code",
      label: "Phone Number",
      className: "col-md-6 mb-3",
      rules: {
        ...(watch("invited_to_maxine") == "1" &&
          watch("email") === "" && {
            validate: (value) => {
              const isInvited = watch("invited_to_maxine") == "1";
              const emailVal = watch("email");

              if (isInvited && !emailVal && !value) {
                return "Please enter phone number or email";
              }
              return true;
            },
          }),
        pattern: {
          value: phoneRegex,
          message: "Please enter a valid phone number",
        },
        ...((!editKey && !profileEdit) ||
          (watch("invited_to_maxine") == "1" &&
            watch("email") == "" && {
              validate: {
                phoneOrEmailRequired: (value) => {
                  const isInvited = watch("invited_to_maxine") == "1";
                  const emailVal = watch("email");

                  if (isInvited && !emailVal && !value) {
                    return "Please enter phone number or email";
                  }

                  return true;
                },
                ...(!editKey &&
                  !profileEdit && {
                    existCheck: async (fieldValue) => {
                      // Check searchproxybyphone
                      const response = await MakeAxiosRequest(
                        "post",
                        "/searchproxybyphone",
                        {
                          phone_number: extractNumbers(fieldValue),
                          country_code: getValues("country_code"),
                        }
                      );
                      return response?.status == 1 || response?.message;
                    },
                  }),
              },
            })),
      },
      // isdisabled: !!editKey || !!profileEdit,
      isdisabled: !!profileEdit,
      mask: "(999) 999-9999",
      type: "phonenumberfield",
      isShow: profileEdit ? false : watch("invited_to_maxine") == 1,
      // isShow: true,
    },
    {
      name: "email",
      label: "Email",
      className: "col-md-6 mb-3",
      // rules: { ...((watch('wallet_permission_enabled')!='1' || watch('invited_to_maxine')=='1') && {required: "Please enter email"} ) },
      // rules: { required: "Please enter email" },
      type: "inputfield",
      isShow: profileEdit ? false : watch("invited_to_maxine") == 1,
    },
  ];

  if (isLoading) return <Loader />;
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitData)}>
          <UpdateInfoLayout
            title={title}
            handleBack={handleBack}
            isSubmitDisabled={isSubmitDisabled}
          >
            <FormFields fields={fields} />
          </UpdateInfoLayout>
        </form>
      </FormProvider>
    </>
  );
}

export default AdditionalOptions;
